"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deployContract = void 0;
/* eslint-disable @typescript-eslint/camelcase */
const config_1 = require("../config/config");
const constants_1 = require("../constants");
const types_1 = require("../types");
const utils_1 = require("../utils");
const ARWEAVE_BASE_URI = 'https://arweave.net';
/**
 * Deploys a contract from a certain contractFactoryId
 * @param DeployContractArgs {@link DeployContractArgs}
 * @returns contract call to be passed to @mintbase-js/sdk execute method
 */
const deployContract = (args) => {
    const { name, factoryContractId = config_1.mbjs.keys.mbContract, ownerId, metadata } = args;
    const { symbol, icon = constants_1.DEFAULT_MB_LOGO, baseUri = ARWEAVE_BASE_URI, reference = null, referenceHash = null } = metadata;
    return {
        contractAddress: factoryContractId || config_1.mbjs.keys.mbContract,
        methodName: types_1.TOKEN_METHOD_NAMES.DEPLOY_TOKEN_CONTRACT,
        args: {
            owner_id: ownerId,
            metadata: {
                spec: constants_1.TOKEN_CONTRACT_SPEC,
                name: (0, utils_1.standardizeString)(name),
                symbol: (0, utils_1.standardizeString)(symbol),
                icon: icon,
                base_uri: baseUri,
                reference: reference,
                reference_hash: referenceHash,
            },
        },
        gas: constants_1.GAS_CONSTANTS.DEFAULT_GAS,
        deposit: constants_1.CONTRACT_DEPOSIT,
    };
};
exports.deployContract = deployContract;
//# sourceMappingURL=deployContract.js.map